module.exports = __webpack_public_path__ + "static/img/dp-banner.37ba213.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/temp/shop/dp-banner.jpg
// module id = TK06
// module chunks = 1